export default __webpack_public_path__ + "static/media/GaugeHighSolid.169ffda8.svg";